import { inputBase } from "./styles";

const fmt = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

const presets = (): { label: string; start: string; end: string }[] => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const week = new Date(today);
  week.setDate(today.getDate() - 6);
  const month = new Date(today.getFullYear(), today.getMonth(), 1);
  return [
    { label: "Today", start: fmt(today), end: fmt(today) },
    { label: "Yesterday", start: fmt(yesterday), end: fmt(yesterday) },
    { label: "Last 7 days", start: fmt(week), end: fmt(today) },
    { label: "This month", start: fmt(month), end: fmt(today) },
  ];
};

// Start/end date inputs plus one-click presets (Today, Yesterday, Last 7 days, This month).
const DateFilter = ({
  startDate,
  endDate,
  onChange,
}: {
  startDate: string;
  endDate: string;
  onChange: (start: string, end: string) => void;
}) => (
  <div className="flex items-center gap-2 flex-wrap">
    <div className="flex items-center gap-2">
      <input
        type="date"
        aria-label="Start date"
        value={startDate}
        onChange={(e) => onChange(e.target.value, endDate)}
        className={inputBase}
      />
      <span className="text-hcMuted text-sm">to</span>
      <input
        type="date"
        aria-label="End date"
        value={endDate}
        onChange={(e) => onChange(startDate, e.target.value)}
        className={inputBase}
      />
    </div>

    <div className="flex items-center gap-1.5 flex-wrap">
      {presets().map((p) => {
        const active = startDate === p.start && endDate === p.end;
        return (
          <button
            key={p.label}
            type="button"
            onClick={() => onChange(p.start, p.end)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition ${
              active
                ? "bg-honeConnectPurple text-white border-honeConnectPurple"
                : "bg-white text-honeConnectGray border-hcBorder hover:bg-hcBg"
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default DateFilter;
